module.exports = __webpack_public_path__ + "img/041-sprout.d3feb76f.svg";